// src/utils/ipfs.js

// This file sets up IPFS using Infura

import { create } from "ipfs-http-client";

let ipfs;

if (
  process.env.REACT_APP_INFURA_API_KEY &&
  process.env.REACT_APP_INFURA_API_SECRET_KEY
) {
  const auth =
    "Basic " +
    btoa(
      process.env.REACT_APP_INFURA_API_KEY +
        ":" +
        process.env.REACT_APP_INFURA_API_SECRET_KEY
    );

  ipfs = create({
    host: "ipfs.infura.io",
    port: 5001,
    protocol: "https",
    apiPath: "/api/v0",
    headers: {
      authorization: auth,
    },
  });
} else {
  console.error("Infura API keys not provided.");
  // You might want to handle this error gracefully based on your application requirements.
}

export default ipfs;
